module.exports = __webpack_public_path__ + "img/gcash-activation-instruction.1a32413b.png";